import { FCX } from '@core/models';
import { components } from '@core/api/api';

type KeyMetricAverages = components['schemas']['KeyMetricAverages'];

function addPercentSign(value?: number | null) {
    return value ? `${value}%` : '—';
}

const CONFIG: Array<{
    title: string;
    key: keyof KeyMetricAverages;
}> = [
    { title: 'avg unbranded PI:', key: 'unbrandedPi' },
    { title: 'avg branded PI:', key: 'brandedPi' },
    { title: 'avg uniqueness:', key: 'uniqueness' },
    { title: 'avg frequency:', key: 'frequency' },
    { title: 'avg draw:', key: 'draw' },
    { title: 'avg value:', key: 'value' },
];

const KeyMetricAverage: FCX<{
    keyMetricAverages?: KeyMetricAverages;
}> = ({ keyMetricAverages }) => {
    if (!keyMetricAverages) {
        return null;
    }

    return (
        <>
            <div className="SurveyDetails__spacer"></div>
            <div className="SurveyDetails__param-column">
                <div className="SurveyDetails__section-title">Key metric averages</div>
                {CONFIG.map((config) => (
                    <div className={'SurveyDetails__param-row'} key={config.key}>
                        <div className="SurveyDetails__param-title">
                            {config.title}
                        </div>
                        <div className="SurveyDetails__param-value">
                            {addPercentSign(keyMetricAverages[config.key])}
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
};

export default KeyMetricAverage;
